import React from 'react';
import './PerfilComponent.css';

const PerfilComponent = () => {
  return (
    <div className="container hero" id="home">
      <div className="hero__grid">
        <div className="hero__media">
          <div className="profile__border">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 500 500"
              style={{ enableBackground: 'new 0 0 500 500' }}
              xmlSpace="preserve"
            >
              <g>
                <path
                  className="st0"
                  style={{
                    fill: 'none',
                    stroke: 'var(--ac)',
                    strokeWidth: 10,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeDasharray: '188.5031, 188.5031',
                  }}
                  d="M471.5,157.6c51.1,122.3-6.7,262.9-129,313.9c-298.7,111-473.7-308.8-184.9-443
                  C279.9-22.5,420.4,35.2,471.5,157.6L471.5,157.6z"
                />
              </g>
            </svg>
            <div className="profile__perfil">
              <img src={`${process.env.PUBLIC_URL}/logito.jpeg`} alt="Ubaldo Canseco" />
            </div>
          </div>
        </div>

        <div className="hero__content">
          <span className="section__eyebrow">&lt;Hello World /&gt;</span>
          <h4 className="profile__name">Ubaldo Canseco</h4>
          <h2 className="profile__profession">
            Full-Stack <span className="resaltado">Web &amp; Mobile</span> Developer
          </h2>
          <ul className="profile__social">
            <a href="https://www.linkedin.com/in/ubaldo-canseco-hernandez/" className="profile__social_link">
              <i className="fi fi-brands-linkedin"></i>
            </a>
            <a href="https://github.com/UbaldoCans" className="profile__social_link">
              <i className="fi fi-brands-github"></i>
            </a>
          </ul>
          <div className="perfil_text">
            <p>
              I am a full-stack web developer with a solid foundation across the JavaScript ecosystem. I hold a
              <span className="resaltado"> Full-Stack JavaScript Web Developer</span> certification from
              <a href="https://kodemia.mx/" target="_blank" rel="noopener noreferrer"> KODEMIA </a> (2021), and completed a professional
              training internship at <a href="https://bosonit.com/" target="_blank" rel="noopener noreferrer"> BOSONIT </a> (2022–2023).
              Since then, I have worked as a web developer at
              <a href="https://www.mainbit.com.mx/" target="_blank" rel="noopener noreferrer"> MAINBIT </a>
              , contributing to internal systems for managing and approving payment requests while continuously
              strengthening my skills across frontend, backend, and cloud technologies.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerfilComponent;
